import React from 'react';
import { VirtualSessionIcon } from '@bizzabo/icons';

const LiveBroadcastLabel = ({ iconElement, label, additionalText, color }) => (
    <div className="broadcast-label-container">
        <div className="broadcast-label">
            {iconElement ? (
                iconElement
            ) : (
                <VirtualSessionIcon
                    className="broadcast-icon"
                    fill={`var(--page-main-color, ${color})`}
                    fontSize="18px"
                />
            )}
            <span className="broadcast-label-text custom-color color-1 font-size-12">{label}</span>
        </div>
        {additionalText && <p className='broadcast-label-additional-text font-size-12'>{additionalText}</p>}
    </div>
);


export default LiveBroadcastLabel;
